import { m as n, f as c, e as t, a as f, j as s } from "./index-5HZ18Wug.js";
import { styled as a, keyframes as h, css as r } from "styled-components";
import { c as g, i as j, p as m } from "./style-V_Aar-SK.js";
import { A as v } from "./aspect-ratios-JlfRqse9.js";
const u = a.div`
  ${n}
  ${c}
`, w = h`

  60%{
    opacity: .6;
  }

`, p = r`
  background-color: ${g.silverLight};
  animation-name: ${w};
  animation-duration: 1800ms;
  animation-fill-mode: forwards;
  animation-timing-function: ${j};
  animation-iteration-count: infinite;
`, k = a.div`
  aspect-ratio: ${({ $aspectRatio: e }) => e || v["8:5"]};
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  ${m(r`
    forced-color-adjust: preserve-parent-color;
  `)}

  ${p}
`, o = a.div`
  ${n}
  width: ${({ width: e }) => e ? `${e}%` : "100%"};
  height: ${({ height: e }) => e ? `${e}px` : t.spacer5};
  position: relative;
  overflow: hidden;
  ${m(r`
    forced-color-adjust: preserve-parent-color;
  `)}

  ${p}
`, C = a.div`
  ${f}
  ${c}
`, R = ({
  aspectRatio: e,
  button: l,
  location: d,
  secondaryTitle: $,
  layout: i = "grid",
  ...x
}) => /* @__PURE__ */ s.jsxs(
  u,
  {
    "data-qa": "tileSkeleton",
    $flexDirection: i === "list" ? { xs: "column", md: "row" } : { xs: "column" },
    $columnGap: i === "list" && { xs: t.spacer1, md: t.spacer4, lg: t.spacer5, xl: t.spacer6 },
    ...x,
    children: [
      /* @__PURE__ */ s.jsx(k, { $aspectRatio: e }),
      /* @__PURE__ */ s.jsxs(C, { $flexDirection: "column", $flexGrow: i === "grid" ? "1" : "2", children: [
        /* @__PURE__ */ s.jsx(o, { height: 20, $mt: { xs: "spacer5", md: i === "grid" ? "spacer5" : "spacer0" }, width: 75 }),
        /* @__PURE__ */ s.jsx(o, { height: 20, $mt: "spacer2" }),
        $ && /* @__PURE__ */ s.jsx(o, { height: 20, $mt: "spacer2", width: 50 }),
        l && /* @__PURE__ */ s.jsx(o, { height: 40, $mt: "spacer2" }),
        d && /* @__PURE__ */ s.jsx(o, { height: 22, $mt: "spacer4", $mb: "spacer1", width: 30 })
      ] })
    ]
  }
);
export {
  p as A,
  o as C,
  k as I,
  R as T,
  u as W
};
